var DateTime, DateTimeParser, moment;

DateTimeParser = require('./date-time-parser');

moment = require('moment');

module.exports = DateTime = (function() {
  function DateTime() {}

  DateTime.parse = function(string) {
    var e, m;
    try {
      return DateTimeParser.parse(string, {
        moment: moment
      }).toDate();
    } catch (error) {
      e = error;
      m = moment(string, moment.ISO_8601, true);
      if (m.isValid()) {
        return m.toDate();
      } else {
        return null;
      }
    }
  };

  DateTime.format = function(dateOrString, showMillisecondsIfNeeded, showSecondsIfNeeded) {
    var e, m;
    if (showMillisecondsIfNeeded == null) {
      showMillisecondsIfNeeded = true;
    }
    if (showSecondsIfNeeded == null) {
      showSecondsIfNeeded = true;
    }
    try {
      m = DateTimeParser.parse(dateOrString, {
        moment: moment
      });
    } catch (error) {
      e = error;
      m = moment(dateOrString, moment.ISO_8601, true);
      if (!m.isValid()) {
        return 'invalid date';
      }
    }
    if (m.milliseconds() && showMillisecondsIfNeeded) {
      return m.format('YYYY-MM-DD HH:mm:ss:SSS');
    } else if (m.seconds() && showSecondsIfNeeded) {
      return m.format('YYYY-MM-DD HH:mm:ss');
    } else if (m.hours() || m.minutes()) {
      return m.format('YYYY-MM-DD HH:mm');
    } else {
      return m.format('YYYY-MM-DD');
    }
  };

  return DateTime;

})();



/*****************
 ** WEBPACK FOOTER
 ** ./lib/date-time.js
 ** module id = 77
 ** module chunks = 0
 **/